module.exports = __webpack_public_path__ + "static/coins_green.cefa89a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/section-voting/images/coins_green.svg
// module id = 648
// module chunks = 132207355946902